import React from 'react';
import formatPrice from '@honda-canada/js-utilities/lib/formatPrice';
import { Box } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import DueAtDelivery from './DueAtDelivery';
import PriceComponent from '../PriceComponent';
import useSellingPriceConfiguration from '../PriceComponent/useSellingPriceConfiguration';
import { selectPaymentOptions } from '../../core/reducers/financialCalculators';
import { useAppSelector } from '../../core/utils';
import { useFetchCurrentVehicleFinancialCalculatorPayment } from '../../core/apiHooks/useFetchPayment';
const priceComponentStyles = {
    priceStyles: {
        container: {
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
        },
        title: {
            size: 'regular',
            styles: {
                fontFamily: 'bold',
                fontWeight: '700',
                textAlign: 'left',
            },
        },
        copy: {
            styles: {
                fontSize: ['16px', '16px', '18px'],
                lineHeight: ['20px', '20px', '22px'],
                fontWeight: '700',
            },
        },
        tooltipContainer: {
            mt: '0',
            tooltip: {
                alignSelf: ['top', 'top', 'center'],
                ml: 'xs',
                mt: ['2px', '4px', '4px'],
            },
        },
    },
};
const compareSectionPriceComponentStyles = {
    priceStyles: {
        container: {
            flexDirection: 'column',
            height: 'auto',
        },
        title: {
            size: 'regular',
            styles: {
                fontSize: ['14px', '14px', '16px'],
                lineHeight: ['22px', '22px', '26px'],
                fontFamily: 'bold',
                mb: ['6px', '6px', '4px'],
            },
        },
        copy: {
            styles: {
                fontSize: ['20px', '20px', '24px'],
                lineHeight: ['24px', '24px', '28px'],
                fontFamily: 'bold',
            },
        },
        tooltipContainer: {
            mt: '0',
            tooltip: {
                alignSelf: 'start',
                ml: 'xs',
                mt: '5px',
            },
        },
    },
};
const priceFormatter = (price, language) => formatPrice(price, language, 2);
const PricePanel = ({ calculatorId, isCompareSection }) => {
    const { t } = useTranslation();
    const { overriddenIsSellingProvince, includeFees } = useAppSelector(state => selectPaymentOptions(state, calculatorId));
    const { data: payment, isFetching, error } = useFetchCurrentVehicleFinancialCalculatorPayment(calculatorId);
    const prices = {
        allInPrice: { ...payment === null || payment === void 0 ? void 0 : payment.sellingPrice, label: t('Shared.Common.sellingPriceLabel') },
        msrpPrice: { ...payment === null || payment === void 0 ? void 0 : payment.sellingPrice, label: t('Shared.Common.sellingPriceLabel') },
    };
    const { sellingPriceTooltipLabelValue } = useSellingPriceConfiguration();
    const sellingPriceTooltipLabel = includeFees
        ? t('Shared.Common.sellingPriceDisclaimerWithTaxLabel')
        : sellingPriceTooltipLabelValue;
    const msrpTooltipLabel = t('Shared.Common.msrpDisclaimerLabel');
    return (React.createElement(Box, null,
        React.createElement(PriceComponent, { allInPriceTooltipLabel: sellingPriceTooltipLabel, errorMessage: t('Pages.Bap.apiLoadingError'), hasError: !!error, height: ['auto', 'auto', undefined], horizontalAlignment: "center", isFetching: isFetching, msrpStartingFromTooltipLabel: msrpTooltipLabel, priceComponentStyles: isCompareSection ? compareSectionPriceComponentStyles : priceComponentStyles, prices: prices, alignItems: undefined, saveAboveLabel: undefined, suppressDiscount: undefined, showSellingPriceDisclaimer: undefined, frieghtPDIFeesCost: undefined, priceFormatter: priceFormatter, errorIconName: "exclamationAlert", overrideShowSellingPrice: overriddenIsSellingProvince, isLoadingIconLarge: true, loadingIconHeight: "28px", dealerFee: undefined, showRebateDisclaimerIndicator: false }),
        React.createElement(DueAtDelivery, { isCompareSection: isCompareSection, calculatorId: calculatorId })));
};
export default PricePanel;
